import { z } from '@customerio/hydra-validation';
import { searchString } from '@/services/router/search-scalars';
import { isEmptyString } from '@/utils/string';
import type { RawSearch } from '../url-state';

/** The two kinds of broadcast the form creates, as the `type` query param names them. */
export const ONE_TIME_SEND = 'newsletters';
export const API_TRIGGERED = 'triggered_broadcast';

/** The server's limit on a broadcast's name. Ember's field allows one more, which the server refuses. */
export const NAME_MAX_LENGTH = 190;

export const NAME_REQUIRED = "Name can't be blank.";
export const TYPE_REQUIRED = 'Select a broadcast type.';

/**
 * The create form. A type is anything but empty, as Ember's check is: an unknown `?type=` passes,
 * and creates a one-time send, which is what Ember does with one.
 */
export const CreateBroadcastSchema = z.object({
  name: z.string().refine((name) => !isEmptyString(name), NAME_REQUIRED),
  broadcastType: z
    .string()
    .nullable()
    .refine((type) => !isEmptyString(type), TYPE_REQUIRED),
  tagIds: z.array(z.string()),
});

export type CreateBroadcastInput = z.input<typeof CreateBroadcastSchema>;
export type CreateBroadcastOutput = z.output<typeof CreateBroadcastSchema>;

export type CreateBroadcastSearch = {
  /** The kind of broadcast picked, which the form opens on and writes back as it changes. */
  type?: string;
  /** Where the form was opened from, for Create Started: the list header, or Goals. */
  source?: string;
};

/** The create form's URL search: `type` and `source` when they're strings, and nothing else. */
export function validateCreateBroadcastSearch(search: RawSearch): CreateBroadcastSearch {
  return { type: searchString(search.type), source: searchString(search.source) };
}
